// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
import { UserLayout } from '@/components/layout'
const systemName='Ment';


/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
    {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/analysis',
        component: "layout/router-view",
        meta: { title: '地址管理', icon: 'dashboard', permission: [ 'dashboard' ] },
        children: [
            {
              path: '/dashboard/analysis',
              name: 'Analysis',
              component: "dashboard/Analysis",
              meta: { title: '站点管理', permission: [ 'dashboard' ] }
            }
        ]
      },
  ]

export const otherRouter = [
    {
        path: '/user',
        name: 'otherRouter',
        component: UserLayout,
        redirect: '/user/login',
        children: [
            {
              path: 'login',
              name: 'login',
              component: () => import(/* webpackChunkName: "user" */ 'page/user/login')
            }
          ]
    },
    {
        path: '/500',
        meta: {
            title: '500-服务端错误 - '+systemName
        },
        name: 'error-500',
        component: () => import('page/error-page/500.vue')
    },
    {
        path: '/403',
        meta: {
            title: '403-权限不足 - '+systemName
        },
        name: 'error-403',
        component: () => import('page/error-page/403.vue')
    },

]